<script setup>
import AddNewUser from "./AddNewUser.vue";
import UsersTable from "./UsersTable.vue";
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <AddNewUser />
      <UsersTable />
    </div>
  </section>
</template>
